<template>
  <div class="form-lower password">
    <lang />

    <section class="wrapper">
      <div class="form_ttl">
        <h1>
          <router-link :to="{ name: 'Home', params: { lang: $route.params.lang }}">
            <img src="@/assets/img/client/logo.png" alt="GLOCALY">
          </router-link>
        </h1>
      </div>
      <div class="password_contents">
        <div>
          <div class="form_wrapper">
            <h2>{{ $t('forgot_password') }}<span class="ilB">{{ $t('forgot_password_span') }}</span></h2>
            <form>
              <label>{{ $t('email_address') }}<input type="text" v-model="email" placeholder="glocaly@example.com"></label>
              <button type="button" class="brown_btn" @click="forgetPassword">{{ $t('send_reset_URL') }}</button>
            </form>
          </div>
          <p>
           <span>{{ $t('if_error_occurs') }}</span><br>
            <span>{{ $t('please_register') }} </span><router-link :to="{ name: 'Client Entry', params: { lang: currentlanguage }}">{{ $t('from_here') }}</router-link>
          </p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import lang from '@/components/client/language/language'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      email: null,
      currentlanguage: this.$route.params.lang
    }
  },
  components: {
    lang
  },
  methods: {
    ...mapActions('login', ['clientForgetPassword']),
    forgetPassword: function () {
      const email = { email: this.email }
      this.clientForgetPassword(email)
    },
    home: function () {
      this.$router.push({ name: 'Client Login' })
    }
  }
}
</script>

<style lang="scss" src="@/assets/sass/client/index.scss">

</style>
